import {
  Button, Card,
  CardActions, CardContent, CardHeader, Checkbox, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle, Divider,
  FormControlLabel,
  Grid, IconButton, TextField, Typography
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import HistoryIcon from '@material-ui/icons/History';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BiBarcodeReader } from "react-icons/bi";
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getKoordinat, GetLocation } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import BarkodPopup from '../../components/BarcodePopup';
import UrunTarihce from '../../components/ProductHistory';
import UrunSearch from '../../components/Selects/ProductSearch';
import SolarBarkodPopup from '../../components/SolarBarkodPopup';
import { text } from '../../modules/languages/index';
import { getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials } from '../../store/actions';
import { setTask } from '../../store/actions/taskActions';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    backgroundColor: red[500],
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
}));

function Urun({ className, FisNo, readonly, tasks, getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials
  , setTask
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const classes = useStyles();
  const [openBarkod, setOpenBarkod] = useState(false);
  const [OpenSolarBarkod, setOpenSolarBarkod] = useState(false);
  const [SolarBarcodeData, setSolarBarcodeData] = useState('');
  const [UrunData, setUrunData] = useState({});
  const [urunTarihceAc, seturunTarihceAc] = useState(false);
  const [maxYil] = useState(new Date().getFullYear());
  const [clearBarkod, setClearBarkod] = useState(false);
  const [search, setSearch] = useState('');
  const [, setFormValid] = useState(true);
  const [formState, setFormState] = useState([
    {
      name: 'SERINO',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: 'Maximum 10 hane girilebilir!...'
    },
    {
      name: 'UYIL',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: `Maximum ${maxYil} girilebilir!...`
    },
    {
      name: 'UDONEM',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: '1 ile 12 arası girilebilir!..'
    }
  ]);
  const [barkod, setBarkod] = useState('');


  useEffect(() => {
    GetLocation();
    let storeData = [];
    if (readonly) {
      storeData = Array.isArray(tasks?.tasks)
        ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))
        : [];
    } else {
      storeData = Array.isArray(loadBaslandiJob())
        ? loadBaslandiJob()
        : [];
    }


    if (Array.isArray(storeData) && storeData.length > 0) {
      setUrunData(storeData[0]);
      setBarkod(storeData[0]?.BARKOD);
    } else {
      setUrunData({});
    }
  }, [FisNo, readonly, tasks]);

  const handleBarkodOpen = () => {
    if (!readonly) {
      setOpenBarkod(true);

    }
  }
  const handleSolarBarkodOpen = () => {
    if (!readonly) {
      setOpenSolarBarkod(true);

    }
  }

  const barkodManipulate = async (maliId) => {
    let result;
    await axios.get(`/GetArtemisBarkodFromMaliId/${maliId}`).then((response) => {
      const data = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : {};
      setBarkod(data?.BARKOD);
      result = data?.BARKOD;
    }).catch(() => {
      setUyari("Barkod Çözümleme Sırasında hata ile karşılaşıldı.");
      setOpen(true);
    });
    return result;
  };

  const handleSolarBarkodClose = async (barkod) => {
    setOpenSolarBarkod(false);
    if (readonly) {
      return;
    }

    if (barkod.length === undefined) {
      return;
    }

    let UrunBarkod = barkod.split("-");

    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    let job = jobs[0];
    job = {
      ...job,
      SolarBarcode: barkod
    }
    saveBaslandiJob(job);
    setSolarBarcodeData(barkod);

    handleBarkodClose(UrunBarkod?.[0]?.toString());


  }

  function getDonemFromHaftaGercek(yil, hafta) {
    var simple = new Date(yil, 0, 1 + (hafta - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    var month = (ISOweekStart.getMonth() + 1).toString().padStart(2, "0");
    return month;
  }

  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    if (readonly) {
      return;
    }

    if (barkod.length === undefined) {
      return;
    }
    setBarkod(barkod);
    if ((barkod.length === 12 || barkod.length === 14) && barkod.substring(0, 1) === 'A' && /^\d+$/.test(barkod.substring(2, 12))) {
      barkod = await barkodManipulate(barkod.substring(0, 12));
    }


    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;

    const job0 = jobs[0];

    if (job0?.MaliId) { // ökc ürünü
      let dbBarkod = job0?.OkcBarkod;
      if (barkod !== dbBarkod) {
        setUyari("Lütfen çağrıdaki " + job0?.MaliId + " maliID ye ait ürün barkodunu okutunuz");
        setOpen(true);
        return;
      }
    }


    var OperationDateParam = moment().utcOffset('+03:00').format('YYYY-MM-DD HH:mm:ss');
    const BarkodTarih = OperationDateParam;
    const BarkodEnlem = getKoordinat("Enlem");
    const BarkodBoylam = getKoordinat("Boylam");
    let txt_nitelik = 0;

    if ([18, 20, 22, 24].indexOf(barkod.length) === -1)
      return;


    var model_length = 0;
    if (barkod.length === 24) {
      model_length = 12;
    } else {
      model_length = barkod.length === 18 ? 6 : 10;
    }
    var txt_kul_model_kodu = barkod.substring(0, model_length);
    var remaining = barkod.substring(model_length, barkod.length);
    var txt_uyıl = '20' + remaining.substring(0, 2);
    var txt_serino = remaining.substring(2, 8);
    var txt_udonem = remaining.substring(8, 10);

    if (txt_kul_model_kodu.slice(-2) === 'RV' || txt_kul_model_kodu.slice(-2) === '99') {
      txt_nitelik = 1;
    }


    if (barkod.length === 24 && model_length === 12 && (txt_kul_model_kodu.startsWith("85999") || txt_kul_model_kodu.startsWith("86999"))) {
      txt_uyıl = '20' + barkod.substring(14, 16);
      var Hafta = barkod.substring(16, 18);
      txt_serino = barkod.substring(18, 24);
      txt_udonem = getDonemFromHaftaGercek(txt_uyıl, parseInt(Hafta));

    }








    let job = jobs[0];

    job = {
      ...job,
      UYIL: parseInt(txt_uyıl),
      UDONEM: parseInt(txt_udonem),
      SERINO: parseInt(txt_serino),
      NITELIK_KODU: parseInt(txt_nitelik),
      BARKOD: barkod,
      BARKODTARIH: BarkodTarih,
      BARKODENLEM: BarkodEnlem,
      BARKODBOYLAM: BarkodBoylam,
    }
    saveBaslandiJob(job);
    setUrunData(job);
    setClearBarkod(false);
    setSearch(txt_kul_model_kodu);
  }

  const fncUrunTarihceAc = () => {
    seturunTarihceAc(true);
  }

  const handleChange = (e) => {
    if (readonly) {
      return;
    }
    const name = e.target.name;
    const value = e.target.value;
    let tmpValid = true;
    for (let i = 0; i < formState.length; i++) {
      const obj = formState[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormState([...formState.slice(0, i), { ...obj, valid: false }, ...formState.slice(i + 1)])
        } else {
          setFormState([...formState.slice(0, i), { ...obj, valid: true }, ...formState.slice(i + 1)])
        }
      }
      tmpValid = tmpValid && obj.valid;
    }

    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;

    setFormValid(tmpValid);
    if (e.target.type === 'checkbox') {
      let value = e.target.checked ? 1 : 0;
      let job = jobs[0];
      job = { ...job, [name]: value };
      saveBaslandiJob(job);
      setUrunData(job);
    } else {
      let obj = formState.filter(f => f.name === name)[0];
      if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
        let job = jobs[0];
        job = { ...job, [name]: value };
        saveBaslandiJob(job);
        setUrunData(job);
      } else {
        const jobs = loadBaslandiJob();
        if (!Array.isArray(jobs) || jobs.length === 0) return;

        let job = jobs[0];
        job = { ...job, [name]: obj.min };
        saveBaslandiJob(job);
        setUrunData(job);
      }
    }
  };

  const setModel = (param) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    let job = jobs[0];
    if (job.KUL_MODEL_KODU !== param.KUL_MODEL_KODU) {
      if (clearBarkod) {
        setBarkod('');
        job = { ...job, BARKOD: '' };
      } else {
        setClearBarkod(true);
      }
      setUyari("Ürün değiştirdiğiniz için fiş üzerindeki hizmet bilgileri silinecektir!");
      setOpen(true);
      resetLabours();
      resetDefects();
      resetMaterials();
      getDefectRequest(param.KUL_MODEL_KODU, 1);
      getMaterialRequest(param.KUL_MODEL_KODU, 1, 1, UrunData.UYIL || 0, UrunData.UDONEM || 0, UrunData.SERINO || '0');
      getLabourRequest(param.KUL_MODEL_KODU, 1, 1);
      job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] }
    }
    job = {
      ...job,
      KUL_MODEL_KODU: param.KUL_MODEL_KODU,
      MODEL: param.ACIKLAMA,
      HOMEWHIZ: param.HOMEWHIZ,
      MARKA_KODU: param.MARKA_KODU,
      TopProductImage: param.TopProductImage
    }
    saveBaslandiJob(job);
    setUrunData(job);
    setTask(job);


  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={"Barkod: " + barkod}
        avatar={
          <IconButton color="primary" aria-label="settings" onClick={handleBarkodOpen}>
            <BiBarcodeReader />
          </IconButton>
        }
      >
      </CardHeader>
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {readonly ?
              <TextField
                label="Ürün"
                type="text"
                value={(UrunData.KUL_MODEL_KODU + ' - ' + UrunData.MODEL) || ''}
                fullWidth
                required
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={readonly}
                variant="outlined"
                helperText={UrunData.MODEL}
              />
              :
              <UrunSearch setModel={setModel} value={{
                KUL_MODEL_KODU: UrunData.KUL_MODEL_KODU,
                ACIKLAMA: UrunData.MODEL
              } || ''}
                searchParam={search}
              />
            }
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={text("uyıl")}
              name="UYIL"
              type="number"
              value={UrunData.UYIL || ''}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              onChange={handleChange}
              variant="outlined"
              error={!formState.filter(n => n.name === "UYIL")?.[0]?.valid}
              helperText={formState.filter(n => n.name === "UYIL")?.[0]?.valid ? '' : formState.filter(n => n.name === "UYIL")?.[0]?.errorMessage}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={text("udonem")}
              name="UDONEM"
              value={UrunData.UDONEM || ''}
              type="number"
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              onChange={handleChange}
              variant="outlined"
              error={!formState.filter(n => n.name === "UDONEM")?.[0]?.valid}
              helperText={formState.filter(n => n.name === "UDONEM")?.[0]?.valid ? '' : formState.filter(n => n.name === "UDONEM")?.[0]?.errorMessage}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={text("serino")}
              name="SERINO"
              type="number"
              value={UrunData.SERINO || ''}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              onChange={handleChange}
              variant="outlined"
              error={!formState.filter(n => n.name === "SERINO")?.[0]?.valid}
              helperText={formState.filter(n => n.name === "SERINO")?.[0]?.valid ? '' : formState.filter(n => n.name === "SERINO")?.[0]?.errorMessage}
            />
          </Grid>
          <Grid item xs={6}>
            {/* <Checkbox
              checked={UrunData.NITELIK_KODU === 1 || false}
              className={classes.policyCheckbox}
              color="primary"
              name="NITELIK_KODU"
              onChange={handleChange}
              disabled={readonly}
            />
            <Typography
              color="textSecondary"
              variant="body1"
            >
              {"Rev(YD)"}
            </Typography> */}
            <FormControlLabel
              disabled={readonly}
              control={<Checkbox color="primary" checked={UrunData.NITELIK_KODU === 1 || false} onChange={handleChange} name="NITELIK_KODU" />}
              label="Yeniden Değerlendirilmiş"
            />

          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              disabled={readonly}
              onClick={handleSolarBarkodOpen}
              endIcon={<WbSunnyIcon>Gönder</WbSunnyIcon>}
            >
              Solar Panel Barkod
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={fncUrunTarihceAc}
              endIcon={<HistoryIcon>Gönder</HistoryIcon>}
            >
              Ürüne Verİlmİş Hİzmetler
            </Button>
          </Grid>
        </Grid>
      </CardActions>
      <Divider />
      {
        (OpenSolarBarkod)
          ? <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Solar Barkod: {SolarBarcodeData}
            </Typography>
          </Grid>
          : <div></div>
      }
      {
        (urunTarihceAc)
          ? <UrunTarihce UrunData={UrunData}></UrunTarihce>
          : <div></div>
      }
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />

      <SolarBarkodPopup
        onClose={handleSolarBarkodClose}
        open={OpenSolarBarkod}
        ScanTime={0}
        CallScreen={0}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Urun.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 }),
  { resetLabours, resetDefects, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest, setTask }
)(Urun);
